export default __webpack_public_path__ + "static/media/search-icon-light.561549cd.svg";